import React from 'react';
import { EeveeImage } from './EeveeImage';
export function Description() {
  return <section className="bg-white/90 dark:bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-200 dark:border-slate-700 shadow-lg transition-colors duration-300" data-id="element-38">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-39">
        <div className="flex-1" data-id="element-40">
          <h2 className="text-2xl font-semibold mb-4 text-amber-600 dark:text-yellow-300" data-id="element-41">
            Description
          </h2>
          <p className="text-slate-700 dark:text-gray-200 leading-relaxed" data-id="element-42">
            This site is a combination of cool facts about Pokémon SV and
            Legends Z-A (coming soon). You can also explore channels that do
            constant giveaways and stay updated on the latest news. (This site
            is still in BETA).
          </p>
        </div>
        <div className="w-32 h-32 md:w-48 md:h-48 flex-shrink-0" data-id="element-43">
          <EeveeImage data-id="element-44" />
        </div>
      </div>
    </section>;
}